import { render, staticRenderFns } from "./CommentListTable.vue?vue&type=template&id=17a59efd&scoped=true&"
import script from "./CommentListTable.vue?vue&type=script&lang=js&"
export * from "./CommentListTable.vue?vue&type=script&lang=js&"
import style0 from "./CommentListTable.vue?vue&type=style&index=0&id=17a59efd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a59efd",
  null
  
)

export default component.exports